import type { ITSPayloadBet, ITSPayloadBoard } from '../../@types/ITSPayload.js';
import Board1x2, { type ITS1X2Board, type ITSUBoard } from '../board/Board1x2.js';
import Bet from './Bet.js';

type ITSERBet1x2Bet = ITSPayloadBet<{
  er1X2BoardData: {
    simpleRowsOnly: boolean;
    boards: ITSPayloadBoard<string>[];
  };
}>;

type ITSBet1x2Bet = ITSPayloadBet<{
  game1X2Boards: (ITS1X2Board | ITSUBoard)[];
}>;

/**
 * Bet class for 1X2 products.
 * Contains product specific logic for eg. reduction systems like RSYS and USYS.
 */
class Bet1X2 extends Bet<Board1x2> {
  getSystemLabel(): string {
    if (this.boards[0]?.systemNumber) {
      return 'TODO';
      // return systems.getSystemKeyFromNumber(this.boards[0].systemNumber);
    }

    if (this.betProperties.includes('REDUCERA_FRITT')) {
      return `reducera fritt ${this.getRowCount()}`;
    }

    const systemType = this.boards[0]?.systemType;
    if (systemType === 'MSYS') {
      return `M ${this.getRowCount()}`;
    }

    return `S ${this.getRowCount()}`;
  }

  protected composeOwnRowsBoards(): ITSERBet1x2Bet {
    const boards = this.boards.map((board) => board.composeOwnRows());
    const itsPayload = {
      er1X2BoardData: {
        simpleRowsOnly: this.isSingleRowsOnly,
        boards,
      },
    };

    type ITSBet1x2 = ITSPayloadBet<typeof itsPayload>;

    return itsPayload as ITSBet1x2;
  }

  protected composeBoards(): ITSBet1x2Bet {
    type ITSPayload1x2Board = ReturnType<Board1x2['compose']>;
    type ITSPayloadUBoard = ReturnType<Board1x2['composeUOutcomes']>;

    const game1X2Boards = this.boards.reduce<(ITSPayload1x2Board | ITSPayloadUBoard)[]>((boards, board) => {
      const nextBoards: (ITSPayload1x2Board | ITSPayloadUBoard)[] = [board.compose()];
      if (board.systemType === 'USYS') {
        const uBoard = board.composeUOutcomes();

        nextBoards.push(uBoard);
      }

      return [...boards, ...nextBoards];
    }, []);

    const itsPayload = {
      game1X2Boards,
    };

    type ITSBet1x2 = ITSPayloadBet<typeof itsPayload>;

    return itsPayload as ITSBet1x2;
  }

  protected getBoard(): Board1x2 {
    return new Board1x2(this.product);
  }
}

export default Bet1X2;
export type Bet1X2Compose = ReturnType<Bet1X2['composeBoards']>;
